import { capitalize } from "lodash";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { formatValueDynamically } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface FallbackPreviewCardProps {
  params: Record<string, unknown>;
  title: string;
  url: string;
}

export const FallbackPreviewCard = ({
  params,
  title,
  url,
}: FallbackPreviewCardProps) => (
  <PreviewCardLayout title={title} url={url}>
    <ul className="flex flex-col leading-5">
      {Object.entries(params || {}).map(([key, value]) => (
        <li key={key} className="text-darkest !pb-0">
          <Typography.BodySm color="text-darkest">
            <strong>{capitalize(key)}:</strong>{" "}
            {formatValueDynamically(value as string | boolean | string[])}
          </Typography.BodySm>
        </li>
      ))}
    </ul>
  </PreviewCardLayout>
);
